import React from 'react';
import { setShowInfo } from '../../redux/myCourse/myCourse.actions';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

import { connect } from 'react-redux';
const InformationModal = ({ information, showInfo, setShowInfo }) => {
	return (
		<Modal
			show={showInfo}
			dialogClassName="modal-90w"
			onHide={() => setShowInfo(false)}
			backdrop={true}
			keyboard={false}
		>
			<Modal.Header closeButton></Modal.Header>
			<Modal.Body size="lg" className="text-center">
				<div className="popup-tick">
					<i className="fa fa-check"></i>
				</div>
				<div dangerouslySetInnerHTML={{ __html: information }} />
				<Button
					aria-label="okay"
					type="button"
					onClick={() => {
						window.location.reload();
					}}
					className=" btn-primary coach-popup-btn"
				>
					Okay
				</Button>
			</Modal.Body>
		</Modal>
	);
};

const mapStateToProps = (state) => {
	const { myCourse } = state.rootReducer;
	return {
		showInfo: myCourse.showInfo,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		setShowInfo: (val) => dispatch(setShowInfo(val)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(InformationModal);
